<template>
	<div class="center_camp_container">
		<div style="display: flex; align-items: flex-end; margin-bottom:20px ;">
			<div style="font-size: 17px; margin-right: 15px;">特训营</div>
			<!-- <div style="font-size: 12px; color: #FBA559; margin-bottom: 3px;">已购</div> -->
		</div>
		<div @click="toDetail(item)"
			style="width: 100%; display: flex; flex-direction: column;cursor: pointer; margin-bottom: 40px; "
			v-for="(item,index) in productData.list" v-if="productData.list && productData.list.length>0">
			<div style="display: flex;">
				<img :src="item.img_url_compressed" style="width: 300px;margin-right: 32px;" />
				<div
					style="flex: 1; display: flex; flex-direction: column; line-height: 1.3; justify-content: space-between; ">
					<div style="display: flex;flex-direction: column;">
						<div style="color: #333;font-size: 14px;">{{item.title}}</div>
						<div style="color: #999;font-size: 13px; margin-top: 5px;">{{item.start_at}}</div>
					</div>
					<div style="margin-top: 13px; display: flex; justify-content: space-between; align-items: flex-end; width: 100%;"
						@click.stop="downloadClick(item.cert_info)">
						<div style="color: #999;font-size: 13px;">
							<div v-if="item.result == 0" @click.stop="toDetail(item)">
								已报名・未缴费 <span
									style="color:#409EFF; border-bottom: 1px solid #409EFF; padding-bottom: 2px;">缴纳报名费</span>
							</div>
							<div v-if="item.result == 1">
								<span v-if="item.is_open_study ==0">已报名・已缴费</span>
								<span v-if="item.is_open_study ==1">有效期：{{item.created_at}} ~ {{item.expire_at}}</span>
							</div>
						</div>
						<el-button size="mini" v-if="item.cert_info && item.cert_info.cert_url">下载培训证书<i
								class="el-icon-download el-icon--right"></i></el-button>
					</div>
				</div>
			</div>
		</div>


		<div class="empty_box" v-if="productData.list && productData.list.length==0">
			<img class="empty_icon" src="../../assets/images/empty.png" />
			<div class="empty_texts" style="" @click="toList()">
				<span class="empty_text" style="font-size: 15px; margin-bottom: 10px;">您尚未加入任何特训营</span>
				<span class="empty_link">去看看有哪些特训营</span>
			</div>
		</div>

	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";
	import download from 'downloadjs';

	export default {
		data() {
			return {
				search: {
					page_index: 1,
					page_size: 30,
					order_by: 'created_at:desc'
				},
				productData: {
					total: 0,
					count: 0,
					list: null,
				},
			};
		},
		created() {
			document.title = "机工教师特训营";
			this.getProductList();
		},
		methods: {
			downloadClick(item) {
				download(item.cert_url, item.title);
			},
			toList() {
				this.GoToChangeTab(27);
			},
			toDetail(item) {
				if (item.is_open_study != 1 || item.result == 0) {
					// this.$alert('您已报名成功，线上内容暂未开放，敬请期待······', '温馨提示', {
					//           confirmButtonText: '确定'
					//   });
					var url = "/trainingCamp/signup";
					var query = {
						id: item.id
					};
					let routeUrl = this.$router.resolve({
						path: url,
						query: query,
					});
					window.open(routeUrl.href, "_blank");
					
				} else {
					var url = "/trainingCamp/study";
					var query = {
						id: item.id
					};
					let routeUrl = this.$router.resolve({
						path: url,
						query: query,
					});
					window.open(routeUrl.href, "_blank");
				}
			},
			getProductList() {
				var that = this;
				var url = apiUrl.tt_purchase_camp_list_get;
				this.Ajax(url, this.search, (data, code, msg) => {
					if (that.productData.total == 0) {
						that.productData.total = data.total;
					}
					if (that.productData.count == 0) {
						that.productData.count = data.count;
					}
					that.productData.list = data.list;
					if (code == 40004 && that.search.page_index == 1) {
						that.productData.list = [];
					}
				});
			},
			currentPage(index) {
				this.search.page_index = parseInt(index);
				this.getProductList();
			}
		},
	};
</script>

<style lang="scss" scoped>
	.center_camp_container {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #fff;
		
		.empty_box {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		
			.empty_icon {
				width: 220px;
				height: auto;
			}
		
			.empty_texts {
				display: flex;
				flex-direction: column;
				color: #C0C4CC;
				line-height: 1;
				cursor: pointer;
		
				.empty_text {
					font-size: 15px;
					margin-bottom: 10px;
		
				}
		
				.empty_link {
					font-size: 17px;
					border-bottom: 1px solid #C0C4CC;
					padding-bottom: 2px;
				}
			}
		}
		
	}	
</style>